<template>
  <div id="area-list">
    <ul class="list">
      <li class="list-item">
        <img src="../assets/images/fy_logo.svg" alt="方舆丈量" />
      </li>
      <li
        class="list-item choose"
        @click="handleShow(1)"
        :class="{ 'is-active': modelValue == 1 }"
      >
        <span>剑川<br />简介</span>
      </li>
      <li
        class="list-item choose"
        @click="handleShow(2)"
        :class="{ 'is-active': modelValue == 2 }"
      >
        <span class="iconfont icon-shaixuan" style="font-size:30px"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mixinModel } from '../../src/assets/js/model';
export default {
  name: 'AreaList',
  data() {
    return {
      active: 1,
      shown: true
    };
  },
  mixins: [mixinModel],
  methods: {
    /**
     * 点击列表回调
     */
    handleShow(flag) {
      if (this.modelValue == flag) {
        this.modelValue = 7;
      } else {
        this.modelValue = flag;
      }
      this.$emit('on-change-list');
    }
  }
};
</script>

<style lang="scss">
#area-list {
  position: fixed;
  z-index: 200;
  .list {
    &-item {
      width: 64px;
      height: 64px;
      margin: 22px 22px;
      line-height: 1.3 !important;
      img {
        width: 64px;
        height: 64px;
      }
    }
    .choose {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 16px;
      border: 2px dashed #fff; /*no*/
      color: #fff;
      background-color: transparent;
      border-radius: 10px;
    }
    .is-active {
      background-color: $primary-light;
      border: 2px solid $primary; /*no*/
      border-radius: 0 !important;
    }
  }
}
@media screen and (max-width: 960px) {
  #area-list {
    top: 30px;
  }
}
</style>
